// extracted by css-extract-rspack-plugin
export default {"ColorPillPicker":"yrUXb"};